// This file based on BE ExceptionCode.java
// https://bitbucket.org/accelaero/aero-suite-auth-service/src/master/src/main/java/com/accelaero/authservice/constants/ExceptionCode.java
const GRPC_AUTH = {
  OK: {},
  CANCELLED: {},

  UNKNOWN: {
    GENERAL: 'ATH-100' // Unexpected error.
  },

  INVALID_ARGUMENT: {
    USER_ID: 'ATH-USR-305', // User id is not found.
    GENERAL: 'ATH-USR-311', // Invalid argument.
    EMAIL: 'ATH-USR-312', // Invalid email.
    USERNAME: 'ATH-USR-313', // Invalid user name.
    DATETIME: 'ATH-USR-314', // Invalid datetime format
    EMPTY_PASS: 'ATH-USR-315' // Password is empty
  },

  DEADLINE_EXCEEDED: {},

  NOT_FOUND: {
    USER: 'ATH-USR-306' // User does not exist.
  },

  ALREADY_EXISTS: {
    USER: 'ATH-USR-304' // User already exists.
  },

  PERMISSION_DENIED: {},

  UNAUTHENTICATED: {
    NO_USERS           : 'ATH-USR-301',   // No users with email or password
    WRONG_TOKEN        : 'ATH-ATH-302',   // here is no such accessToken
    WRONG_REFRESH_TOKEN: 'ATH-ATH-303',   // here is no such refreshToken
    INCORECT_OR_EXPIRED: 'ATH-ATH-304',   // Token is incorrect or expired
    WRONG_TICKET       : 'ATH-ATH-305',   // here is no such ticket

    REQUIRED_CHANGE_PASS: 'ATH-USR-303',   // User with auth type USERNAME should change password for the first login
    USER_DELETED        : 'ATH-USR-306',   // User DELETED
    USER_INACTIVE       : 'ATH-USR-307',   // User INACTIVE
    NEED_CAPTCHA        : 'ATH-USR-308',   // Need captcha
    ACCOUNT_LOCKED      : 'ATH-USR-309',   // Account is locked
    USE_INVITATION      : 'ATH-USR-310',    // User with auth type EMAIL should use flow with INVITED
    NOT_VALID_STATUS    : "ATH-USR-311",   // User has not valid status
    USER_ORG_INACTIVE   : "ATH-USR-314",   // User organization status is Inactive
    USER_PASS_EXPIRED   : "USC-USR-403",   // User password expired
  },

  RESOURCE_EXHAUSTED: {},

  FAILED_PRECONDITION: {
    EMAIL: 'ATH-USR-302' // User mail should me email.
  },

  ABORTED: {
    WRONG_ID: 'ATH-USR-307' // User id mismatch.
  },

  OUT_OF_RANGE: {},
  UNIMPLEMENTED: {},

  INTERNAL: {
    INVALID_STATUS: 'ATH-USR-308',   // Existing user status is invalid.
    SERVICE       : 'ATH-SSE-371'    // Service setup error
  },

  UNAVAILABLE: {},
  DATA_LOSS: {}
};

export default GRPC_AUTH;
